.right {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 3.2rem;
  min-width: 12rem;
  font-size: 1.4rem;
  font-weight: 400;
  color: var(--color-grayscale-white);

  & > div {
    text-transform: capitalize;
  }
}
